ready = ->
  $("body").on "click", ".add-collector-type-btn", (e) ->
    $('#edit_collector_type').addClass 'hide'
    $('#register_collector_type').removeClass 'hide'

  $("body").on "click", ".edit-collector-type-btn", (e) ->
    $('#edit_collector_type').removeClass 'hide'
    $('#register_collector_type').addClass 'hide'

$(document).on 'turbolinks:load', ready